
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sportssummit26",
      function () {
        return require("private-next-pages/sportssummit26/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sportssummit26"])
      });
    }
  